import { HfsSettingsActionEnum } from 'fleet-data-model';
import { type Update } from '../../types';

export const mapFacilityModeEnabledExecutionTargets = (update: Update) => {
  return [
    {
      hfsActionId: HfsSettingsActionEnum.FACILITY_MODE_ENABLED,
      iprId: update.assetId,
      payload: {
        enabled: update.enabled,
      },
    },
  ];
};
